<script lang="ts">
  import { appState } from '../state.svelte';

  let { onOpen }: { onOpen: () => void } = $props();

  function dismiss() {
    appState.welcomePopup.visible = false;
    appState.welcomePopup.dismissed = true;
  }

  function handleOpen() {
    dismiss();
    onOpen();
  }
</script>

{#if appState.widgetConfig && appState.welcomePopup.visible}
  <div
    class="tashimoto-support-welcome-popup tashimoto-support-fixed tashimoto-support-bottom-24 tashimoto-support-right-6 tashimoto-support-w-[300px]"
    style="z-index: {appState.zIndex};"
    data-testid="welcome-popup"
  >
    <div class="tashimoto-support-welcome-card tashimoto-support-relative tashimoto-support-bg-white tashimoto-support-rounded-2xl tashimoto-support-overflow-hidden">
      <div class="tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-between tashimoto-support-px-4 tashimoto-support-py-2.5 tashimoto-support-bg-gray-50 tashimoto-support-border-b tashimoto-support-border-gray-100">
        <div class="tashimoto-support-flex tashimoto-support-items-center tashimoto-support-gap-2">
          <span class="tashimoto-support-w-2 tashimoto-support-h-2 tashimoto-support-rounded-full tashimoto-support-bg-green-500"></span>
          <span class="tashimoto-support-text-xs tashimoto-support-font-semibold tashimoto-support-text-gray-700 tashimoto-support-truncate">
            {appState.widgetConfig.name}
          </span>
        </div>
        <button
          type="button"
          class="tashimoto-support-w-5 tashimoto-support-h-5 tashimoto-support-rounded-full tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center tashimoto-support-text-gray-400 hover:tashimoto-support-text-gray-700 hover:tashimoto-support-bg-gray-200 tashimoto-support-text-base tashimoto-support-leading-none"
          aria-label="Dismiss popup"
          onclick={dismiss}
        >
          &times;
        </button>
      </div>

      <button
        type="button"
        class="tashimoto-support-block tashimoto-support-text-left tashimoto-support-w-full tashimoto-support-px-4 tashimoto-support-py-3 tashimoto-support-text-sm tashimoto-support-text-gray-800 tashimoto-support-leading-relaxed hover:tashimoto-support-bg-gray-50 tashimoto-support-transition-colors"
        onclick={handleOpen}
        data-testid="welcome-popup-open"
      >
        {appState.widgetConfig.welcome_popup_message}
      </button>
    </div>

    <div
      class="tashimoto-support-welcome-tail tashimoto-support-absolute"
      aria-hidden="true"
    ></div>
  </div>
{/if}

<style>
  .tashimoto-support-welcome-popup {
    animation: tashimoto-support-popup-in 240ms cubic-bezier(0.18, 0.89, 0.32, 1.28);
    transform-origin: bottom right;
  }
  .tashimoto-support-welcome-card {
    border: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow:
      0 2px 4px rgba(15, 23, 42, 0.06),
      0 12px 32px rgba(15, 23, 42, 0.18);
  }
  .tashimoto-support-welcome-tail {
    bottom: -7px;
    right: 22px;
    width: 14px;
    height: 14px;
    background: #ffffff;
    transform: rotate(45deg);
    border-right: 1px solid rgba(15, 23, 42, 0.08);
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 3px 3px 6px rgba(15, 23, 42, 0.08);
  }
  @keyframes tashimoto-support-popup-in {
    from {
      opacity: 0;
      transform: translateY(10px) scale(0.94);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
</style>
